export interface FormState {
  isValid: boolean
  formId?: string
}

export interface HeaderState {
  title: string;
  subtitle?: string;
  reportState?: {
    isValidSSN?: boolean;
  };
}
